import React from 'react';

const RunbookCreateTicket = (props) => (
    <svg width="1em" height="1em" viewBox="0 0 14 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M1.21729 2.22656C1.21729 1.81235 1.55307 1.47656 1.96729 1.47656H4.87905C4.87905 1.47656 5.13053 3.26842 6.97382 3.26842C8.81712 3.26842 9.0686 1.47656 9.0686 1.47656H11.9844C12.3987 1.47656 12.7344 1.81235 12.7344 2.22656V17.7266C12.7344 18.1408 12.3987 18.4766 11.9844 18.4766H9.0686C9.0686 18.4766 8.97744 16.6863 6.95808 16.6863C4.87905 16.6863 4.87905 18.4766 4.87905 18.4766H1.96728C1.55307 18.4766 1.21729 18.1408 1.21729 17.7266V2.22656Z" stroke="currentColor"/>
        <path d="M1.23584 5.94336H12.7923" stroke="currentColor"/>
        <path d="M3.05029 9.5293H10.8687" stroke="currentColor" strokeLinecap="round"/>
        <path d="M3.7168 12.2207H10.2084" stroke="currentColor" strokeLinecap="round"/>
</svg>
);

export default RunbookCreateTicket;
